export default "__VITE_PUBLIC_ASSET__4e8c5909__"